export default [
  {
    path: "/student-list",
    component: (resolve) => require(["@/vuepage/student-manage/index.vue"], resolve),
    meta: [
      {
        name: "学员管理",
      },
      {
        name: "学员列表",
        activeRoute: "/student-list",
      },
    ],
  },
  {
    path: "/student-detail",
    component: (resolve) => require(["@/vuepage/student-manage/detail.vue"], resolve),
    meta: [
      {
        name: "学员管理",
      },
      {
        name: "学员详情",
        activeRoute: "/student-list",
      },
    ],
  },
  {
    path: "/student-add",
    component: (resolve) => require(["@/vuepage/student-manage/add.vue"], resolve),
    meta: [
      {
        name: "学员管理",
      },
      {
        name: "新增学员",
        activeRoute: "/student-list",
      },
    ],
  },
];
